import React, { useState, useCallback, useEffect } from 'react';
import { Slider, Box } from '@mui/material';
import { FaCircleChevronRight, FaCircleChevronLeft, FaCalendarDays } from "react-icons/fa6";
import Cropper from 'react-easy-crop';
const SplitPreview = ({ value, value1, camera }) => {

    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [loading, setLoading] = useState(false);
    return (<>
        <Box className={'cambg'} position={'relative'} zIndex={10} sx={{ height: '100vh' }}>
            <Box sx={{ display: 'flex', flex: '1 1 ' }}>
                <Box
                    className="crop-container"
                    sx={{ position: 'relative', width: 1, borderRight: '1px solid white' }}
                >
                    <Cropper
                        crop={crop}
                        image={value}
                        zoom={zoom}
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        cropShape="rectangle"
                        onMediaLoaded={() => setLoading(false)}
                        maxZoom={8}
                        objectFit="horizontal-cover"
                    />
                </Box>
                <Box
                    className="crop-container"
                    sx={{ position: 'relative', height: '72vh', width: 1, borderLeft: '1px solid white' }}
                >
                    <Cropper
                        crop={crop}
                        image={value1 || value}
                        zoom={zoom}
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        cropShape="rectangle"
                        onMediaLoaded={() => setLoading(false)}
                        maxZoom={8}
                        objectFit="horizontal-cover"
                    />
                </Box>
            </Box>
            <Box sx={{ width: 200, mx: 'auto', textAlign: 'center', py: 0.5 }}>
                <Slider
                    value={zoom}
                    onChange={(_, newValue) => setZoom(newValue)}
                    step={0.1}
                    min={2}
                    max={8}
                    aria-labelledby="zoom-slider"
                    sx={{ color: '#ffd80c' }}
                />
            </Box>
        </Box>
    </>
    )
}
export default SplitPreview
